export default __webpack_public_path__ + "img/4da79ae3a5581d0445887db9291ec4eb.png";